import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PricesService } from '../../services/prices.service';
import { EcurrenciesService } from '../../services/ecurrencies.service';
/**
 * Prices Component
 */
let PricesComponent = class PricesComponent {
    constructor(httpClient, webSettingsService, sanitizer, themeService, pricesService, ecurrenciesService) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.pricesService = pricesService;
        this.ecurrenciesService = ecurrenciesService;
        this.prices = {};
        this.percent = {};
        this.allPrices = [];
        this.allPercents = [];
        this.backColor = '';
        this.percentUp = '';
        this.percentDown = '';
        this.borderRadiusLarger = '';
        this.currencySettingsValue = '';
        this.ecurrencies = [];
        this.show = true;
        this.pricesSpinner = true;
        this.changesSpinner = true;
        this.changesError = true;
        this.pricesError = true;
        this.errorString = 'N/A';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.percentUp = this.themeService.getStyleAttribute('prices_up_color');
            this.percentDown = this.themeService.getStyleAttribute('prices_down_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.webSettingsService.getSettings().subscribe((data) => {
            this.errorString = this.webSettingsService.getKeyValue("ERROR.NO_ANSWER") !== '' ? this.webSettingsService.getKeyValue("ERROR.NO_ANSWER") : 'N/A';
        });
        this.pricesService.getChanges().then((data) => {
            if (data) {
                this.allPercents = this.pricesService.getArrayChanges();
                this.changesSpinner = false;
                this.changesError = false;
            }
            else {
                this.changesSpinner = false;
                this.changesError = true;
            }
        });
        this.pricesService.getPrices().then((result) => {
            if (result) {
                this.allPrices = this.pricesService.getArrayPrices();
                this.pricesSpinner = false;
                this.pricesError = false;
            }
            else {
                this.pricesSpinner = false;
                this.pricesError = true;
            }
        });
        this.ecurrenciesService.getEcurrencies().then((res) => {
            if (res) {
                this.ecurrencies = this.ecurrenciesService.getAllEcurrencies();
                this.show = true;
            }
            else {
                this.show = false;
            }
        });
    }
};
PricesComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: PricesService },
    { type: EcurrenciesService }
];
PricesComponent = __decorate([
    Component({
        selector: 'ecd-prices',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./prices.component.html")).default
    })
], PricesComponent);
export { PricesComponent };
